import { Feature } from '@ardoq/api-types';
import { featureOperations } from '@ardoq/features';
import { getFeatureContext } from 'streams/featureContext$';

/**
 * `featureInterface` is part of the Backbone-era model interface layer: it
 * snapshots the feature context via `getFeatureContext()` at call time.
 *
 * The app is stream-based now. Join `featureContext$`
 * (`streams/featureContext$.ts`) at a permitted boundary -- a `*$.ts` file, a
 * file inside a `*$/` folder, or a `*routines.ts` -- and pass the resolved
 * context to the pure `featureOperations.hasFeature` (`@ardoq/features`), which
 * this member already delegates to. Consumers reach this through the
 * already-deprecated `hasFeature` stub in `@ardoq/features`.
 *
 * @deprecated Join `featureContext$` and call
 * `featureOperations.hasFeature(featureContext, feature)` (`@ardoq/features`)
 * with the resolved context. See
 * `packages/eslint-plugin-ardoq-lint/docs/rules/no-model-interface-call.md`
 * for the hoisting recipe.
 */
export const hasFeature = (feature: Feature): boolean => {
  return featureOperations.hasFeature(getFeatureContext(), feature);
};
